/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable consistent-return */
// eslint-disable-next-line no-use-before-define
import React, { ReactElement, useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Divider,
  notification,
} from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Redirect, useHistory } from 'react-router-dom';

import { config } from 'core/config';
import { ApplicationState } from 'store/combineReducers';
import { useTranslation } from 'react-i18next';
import LocalesDropdown from 'layout/components/localesDropdown';
import { setStoreLanguage } from 'utils/localStorage';
import { changeLanguageTmp } from 'i18n';
import { debounce } from 'utils/util';
import { DeleteOutlined } from '@ant-design/icons';
import { languageMap } from 'constant/common';
import { apiCheckTenant } from './signEntry.service';
import './index.less';

const { Item } = Form;

export interface SignInFormData {
  email: string;
  password: string;
  request: string | undefined;
}

interface SignInProps {
  request: string;
}
export default function SignEntry({ request }: SignInProps): ReactElement {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [tenantData, setTenantData] = useState<Record<string, any>>({});
  const [tenants, setTenants] = useState<string[]>(
    JSON.parse(localStorage.getItem('tenants') || '[]'),
  );
  const [inputValue, setInputValue] = useState<any>('');
  const [validateStatus, setValidateStatus] = useState<any>('');
  const [validateMessage, setValidateMessage] = useState('');
  const [domainUrl, setDomainUrl] = useState(
    window?.__APP_CONFIG__?.DOMAIN_URL || process.env.DOMAIN_URL || 'localhost',
  );
  const { isAuth, user } = useSelector(
    (state: ApplicationState) => state.session,
  );
  const [responseErrorMessage, setResponseErrorMessage] = useState('');
  const searchParams = new URLSearchParams(history?.location?.search);

  useEffect(() => {
    if (window?.__APP_CONFIG__?.DOMAIN_URL) {
      setDomainUrl(window?.__APP_CONFIG__?.DOMAIN_URL);
    }
  }, [window?.__APP_CONFIG__?.DOMAIN_URL]);

  async function validateTenant() {
    const { host, protocol } = window.location;
    if (host.includes('.')) {
      const hostArr = host.split('.');
      try {
        const res = await apiCheckTenant(hostArr[0]);
        if (res.status === 200) {
          localStorage.setItem('tenantData', JSON.stringify(res.data));
          window.location.href = `${protocol}//${host}${config.paths.signIn}`;
        }
      } catch {
        console.log('error');
      }
    }
  }

  useEffect(() => {
    if (domainUrl !== window.location.hostname) {
      validateTenant();
    }
    const language = searchParams.get('language');
    if (language != null) {
      const lan = languageMap[language] || language;
      setStoreLanguage(lan);
      setStoreLanguage(language);
      changeLanguageTmp();
    }
  }, [history]);

  const handleJump = (ten = inputValue) => {
    const { protocol } = window.location;
    window.location.href = `${protocol}//${ten}.${domainUrl}${config.paths.signIn}`;
  };

  function handleSubmit() {
    console.log('submit');
    if (inputValue && validateStatus === 'success') {
      tenants.push(inputValue);
      localStorage.setItem('tenants', JSON.stringify(tenants));
      handleJump();
    }
  }

  async function inputChange(e: any) {
    console.log(e.target.value);
    setValidateStatus('');
    setValidateMessage('');
    setInputValue(e.target.value);
    if (!e.target.value) {
      return;
    }
    setLoading(true);
    try {
      const response = await apiCheckTenant(e.target.value);
      if (response.status === 200) {
        setTenantData(response.data);
        localStorage.setItem('tenantData', JSON.stringify(response.data));
      }
      setValidateStatus('success');
      setLoading(false);
    } catch (error) {
      setValidateStatus('error');
      setValidateMessage(t('login.tenant.checkError'));
    } finally {
      setLoading(false);
    }
  }

  const handleChange = debounce(inputChange, 700);

  console.log(
    'window?.__APP_CONFIG__?.DOMAIN_URL',
    window?.__APP_CONFIG__?.DOMAIN_URL,
  );

  const renderCache = () => {
    if (tenants.length > 0) {
      return (
        <>
          <div className="recent">
            <Divider>{t('common.RECENT_TENANTS')}</Divider>
            <div className="list">
              {tenants.map((tenant: string) => {
                return (
                  <div key={tenant} className="item">
                    <div className="text">
                      <p className="name">
                        {tenant}
                        <Button
                          className="button"
                          type="link"
                          danger
                          size="small"
                          onClick={() =>
                            setTenants(
                              tenants.filter((item: string) => item !== tenant),
                            )
                          }
                        >
                          <DeleteOutlined />
                        </Button>
                      </p>
                      <p className="email">
                        {tenant}.{domainUrl}
                      </p>
                    </div>
                    <div className="action">
                      <Button
                        type="primary"
                        size="small"
                        ghost
                        onClick={() => handleJump(tenant)}
                      >
                        {t('common.launch')}
                      </Button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      );
    }
  };
  return (
    <Row
      justify="center"
      align="middle"
      className="full-height-page with-header"
      style={{ marginTop: '50px' }}
    >
      <Col style={{ width: '390px' }}>
        <PageHeader title={t('signEntry.form.label')} />
        <Card>
          <Form layout="vertical">
            <Item
              label={t('common.domain')}
              validateStatus={validateStatus}
              help={validateMessage}
            >
              <Input
                onChange={handleChange}
                addonBefore="https://"
                addonAfter={`.${domainUrl}`}
                placeholder={t('common.tenant')}
              />
            </Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{ width: '100%' }}
              onClick={handleSubmit}
              loading={loading}
              disabled={!inputValue || validateStatus !== 'success'}
            >
              {t('common.continue')}
            </Button>
          </Form>
          {renderCache()}
          <LocalesDropdown />
        </Card>
        <div
          style={{
            paddingTop: '20px',
            textAlign: 'end',
            paddingRight: '5px',
            fontSize: '12px',
          }}
        >
          <a href="https://www.vivalink.com/terms-conditions" target="_blank">
            {t('signIn.aHref.termsConditions')}
          </a>
          <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <a href="https://www.vivalink.com/privacy-policy" target="_blank">
            {t('signIn.aHref.privacyPolicy')}
          </a>
        </div>
      </Col>
    </Row>
  );
}
